<!-- REMINDER:
  If you only want the modal to close only without any behavior,
  usually @cancel-click and @hidden are used together
  eg. @cancel-click="showModal = false" @hidden="showModal = false"
-->
<template>
  <div style="display: none;">
    <b-modal
      :id="id"
      :visible="isOpen"
      :title="title"
      centered
      hide-footer
      no-enforce-focus
      @hidden="$emit('hidden')"
      :hide-header-close="hideHeaderClose"
      :size="size"
    >
      <template v-slot:modal-header>
        <slot name="modalHeader"></slot>
      </template>
      <div class="container">
        <div class="row">
          <div class="col-12">
            <slot></slot>
          </div>
          <footer class="col-12" :class="footerClass" v-if="showFooter">
            <b-button
              v-if="showCancelButton"
              :variant="cancelVariant"
              :disabled="loading"
              @click="$emit('cancel-click')"
            >
              {{ cancelTitle }}
            </b-button>
            <b-button :variant="okVariant" :disabled="isDisabled || loading"
            @click="$emit('ok-click')">
              <span>{{ okTitle }}</span>
            </b-button>
          </footer>
        </div>
      </div>
      <LoadingSpinner v-show="loading"></LoadingSpinner>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BModal } from 'bootstrap-vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  name: 'BaseActionModal',
  props: {
    loading: {
      type: Boolean,
    },
    id: String,
    isOpen: Boolean,
    title: String,
    isDisabled: Boolean,
    cancelTitle: {
      type: String,
      default: '取消',
    },
    okTitle: {
      type: String,
      default: '確定',
    },
    cancelVariant: {
      type: String,
      default: 'outline-secondary',
    },
    okVariant: {
      type: String,
      default: 'success',
    },
    hideHeaderClose: Boolean,
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    footerClass: {
      type: String,
      default: 'd-flex justify-content-end',
    },
    size: {
      type: String,
      default: 'md',
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    BButton,
    BModal,
    LoadingSpinner,
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .modal {
    &-md {
      max-width: 600px;
    }

    &-header {
      padding: 24px;
      border: none;
    }

    &-title {
      margin: 0 auto;
      font-size: 18px;
      font-weight: 400;
      color: #3a4047;
    }

    &-header .close {
      margin-left: 0;
      margin-top: -12px;
      font-size: 20px;
    }

    &-body {
      padding: 0 24px 24px 24px;
    }

    &-body .col-12 {
      padding: 0;
    }

    .btn {
      margin-top: 24px;
      margin-left: 12px;
      width: 115px;
      padding: 10px 16px;

      &-success {
        background-color: #36b674 !important;
        border-color: #36b674 !important;
      }

      &-outline-secondary {
        background-color: #f9f9fa !important;
        border: 1px solid #dde1e5 !important;

        &:hover {
          background-color: #636d77 !important;
          border: 1px solid #636d77 !important;
        }
      }
    }
  }
}
</style>
